import React, {useEffect} from 'react'
import {Container, Grid} from '@chakra-ui/react'
import useMultiSite from '../../hooks/use-multi-site'
import useOcapiSite from '../../hooks/useOcapiSite'
import useEffectEvent from '../../hooks/use-effect-event'
import HeaderContent from '../../components/header-content'

const ReturnOrder = () => {
    const {locale} = useMultiSite()
    const [language, region] = locale.id.toLowerCase().split('-')
    const {parcellabUserId, parcellabReturnOrderJS, parcellabReturnOrderCSS} = useOcapiSite()

    const onMount = useEffectEvent(() => {
        const existing = document.getElementById('pl-returns-plugin-js')
        if (!existing) {
            const script = document.createElement('script')
            script.id = 'pl-returns-plugin-js'
            script.src = parcellabReturnOrderJS
            script.async = true
            document.body.appendChild(script)

            const linkTag = document.createElement('link')
            linkTag.id = 'pl-returns-plugin-css'
            linkTag.rel = 'stylesheet'
            linkTag.href = parcellabReturnOrderCSS
            document.getElementsByTagName('head')[0].appendChild(linkTag)
        }
    })
    useEffect(() => {
        onMount()
    }, [onMount])

    return (
        <>
            <HeaderContent />
            <Container px={2} data-testid="sf-shipment-tracking">
                <Grid align={'center'}>
                    <React.Fragment>
                        <div
                            id="pl-returns-plugin"
                            data-user={parcellabUserId}
                            data-lang-code={language}
                            data-country-code={region}
                        ></div>
                    </React.Fragment>
                </Grid>
            </Container>
        </>
    )
}

export default ReturnOrder
